import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import documentListItemAdded, {
	type DocumentListItemAddedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemAdded';
import documentListItemAdditionFailed, {
	type DocumentListItemAdditionFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemAdditionFailed';
import type AddDocumentListItem from '@Application/Beneficiaries/Documents/Commands/AddDocumentListItem';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentListItemAddedAction | DocumentListItemAdditionFailedAction;

export default (command: AddDocumentListItem) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/lists/${encodeURIComponent(command.listKey)}/items`,
				command.toJSON(),
			);

			const action = documentListItemAdded(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentListItemAdditionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
